import Page from 'views/Login/Login'

export default Page
